'use strict';
function hallsoBuild(config, choice, fabrics, group) {
  const find = (list, id) => {
    const x = list.find(v => v.id === id);
    if (!x) throw Error('Valget finnes ikke. Velg på nytt.');
    return x;
  };

  if (!group) throw Error('Konfigurasjonsreferanse mangler.');
  if (!['', 'lille', 'store'].includes(choice.mattress)) throw Error('Velg madrass.');
  if (config.width === 210 && choice.mattress === 'lille') {
    throw Error('Lille Harpö finnes ikke i 210 cm bredde. Velg Store Harpö eller uten madrass.');
  }

  const topper = choice.topper ? find(config.topper, choice.topper) : null;
  const headboard = choice.headboard ? find(config.headboards, choice.headboard) : null;
  const upholstered = config.model === 'hallso-fabric' || Boolean(choice.mattress || topper?.name.startsWith('Luxury') || headboard?.needsFabric);
  const fabric = upholstered ? fabrics.find(f => f.key === choice.fabric) : null;

  if (upholstered && !fabric) throw Error('Velg tekstil.');

  const lines = [];

  const add = (item, role, properties = {}, quantity = 1) => {
    if (!/^\d+$/.test(item.id) || !Number.isSafeInteger(item.price) || item.price < 0) {
      throw Error('Pris eller variant mangler.');
    }

    lines.push({
      id: item.id,
      quantity,
      name: item.name,
      unitPrice: item.price,
      properties: {
        _cdb_configuration: group,
        _cdb_role: role,
        _cdb_version: '2',
        _cdb_product_heading: 'Hällsö ' + (config.model === 'hallso-fabric' ? 'Fabric' : 'Walnut') + ' rammeseng',
        Konfigurasjon: 'Hällsö ' + (config.model === 'hallso-fabric' ? 'Fabric' : 'Walnut') + ' ' + config.width + ' × ' + config.length,
        Komponent: item.name,
        ...properties
      }
    });
  };

  const fee = (rule, target, quantity = 1) => {
    if (fabric?.collection === 'Exclusive') {
      add(
        { ...config.fees[rule], name: 'Exclusive tekstil · ' + target },
        rule,
        { Tekstil: fabric.name, Gjelder: target },
        quantity
      );
    }
  };

  if (config.model === 'hallso-fabric' && fabric?.collection === 'Exclusive') {
    if (!config.fees.frame) throw Error('Exclusive-tillegg for tekstilrammen må bekreftes. Velg Classic foreløpig.');
    fee('frame', 'Stofftrukket ramme');
  }

  add(config.base, 'bed', {
    'Størrelse': config.width + 'x' + config.length + ' cm',
    'Utførelse': config.model === 'hallso-fabric' ? 'Tekstil' : 'Valnøtt',
    ...(config.model === 'hallso-fabric' ? { 'Tekstil': fabric.name } : {}),
    'Madrass': choice.mattress
      ? choice.mattress === 'lille' ? 'Lille Harpö' : 'Store Harpö'
      : 'Uten madrass',
    'Gavl': headboard?.name || 'Uten gavl',
    'Overmadrass': topper?.name || 'Uten overmadrass'
  });

  if (choice.mattress) {
    const ranks = [
      config.firmness.indexOf(choice.left),
      config.firmness.indexOf(choice.right)
    ];

    if (ranks.some(n => n < 0)) throw Error('Velg fasthet på begge sider.');

    ranks.sort((a, b) => a - b);

    const name = ranks[0] === ranks[1]
      ? config.firmness[ranks[0]]
      : ranks.map(n => config.firmness[n]).join('/');

    const mattress = config.mattresses[choice.mattress].find(x => x.name === name);

    if (!mattress) throw Error('Fasthetskombinasjonen mangler.');

    add({
      ...mattress,
      name: (choice.mattress === 'lille' ? 'Lille' : 'Store') +
        ' Harpö ' + config.width + ' × ' + config.length
    }, 'mattress', {
      'Venstre fasthet': choice.left,
      'Høyre fasthet': choice.right,
      'Orientering': 'Sett fra fotenden mot hodeenden',
      'Tekstil': fabric.name
    });

    fee('harpo', 'Harpö');
  }

  if (topper) {
    const luxury = topper.name.startsWith('Luxury');
    add(topper, 'topper', luxury ? { Tekstil: fabric.name } : {});
    if (luxury) fee('luxury_topper', 'Luxury overmadrass');
  }

  if (headboard) {
    add(headboard, 'headboard', headboard.needsFabric ? { Tekstil: fabric.name } : {});
    if (headboard.needsFabric) {
      fee(headboard.feeRule, 'Gavl', headboard.feeQuantity);
    }
  }

  const manifest = lines
    .map(l => l.properties._cdb_role + ':' + l.id + ':' + l.quantity)
    .sort()
    .join('|');

  lines.forEach(l => l.properties._cdb_manifest = manifest);

  return {
    lines,
    total: lines.reduce((s, l) => s + l.unitPrice * l.quantity, 0),
    cart: {
      items: lines.map(({ id, quantity, properties }) => ({
        id, quantity, properties
      }))
    }
  };
}

if (typeof module !== 'undefined') module.exports = { hallsoBuild };

if (typeof document !== 'undefined') (() => {
  const root = document.querySelector('[data-hallso-pilot]');
  if (!root) return;

  const config = JSON.parse(root.querySelector('[data-config]').textContent);
  const size = root.querySelector('[data-hallso-size]')?.value;
  const isFabric = root.dataset.hallsoModel === 'fabric';
  if (isFabric) config.model = 'hallso-fabric';

  const firmnessNames = [
    'Soft', 'Soft/Medium', 'Soft/Firm', 'Soft/Extra Firm',
    'Medium', 'Medium/Firm', 'Medium/Extra Firm',
    'Firm', 'Firm/Extra Firm', 'Extra Firm'
  ];

  if (size === '180x210') {
    config.width = 180;
    config.length = 210;
    config.base = {
      id: '54493794730348',
      name: 'Hällsö Walnut 180 × 210 – ramme',
      price: 6820000
    };

    const lilleIds = [
      '52037483987308', '52037484020076',
      '52037484052844', '52037484085612',
      '52037484118380', '52037484151148',
      '52037484183916', '52037484216684',
      '52037484249452', '52037484282220'
    ];

    const storeIds = [
      '52037486641516', '52037486674284',
      '52037486707052', '52037486739820',
      '52037486772588', '52037486805356',
      '52037486838124', '52037486870892',
      '52037486903660', '52037486936428'
    ];

    config.mattresses = {
      lille: lilleIds.map((id, i) => ({
        id, name: firmnessNames[i], price: 4092000
      })),
      store: storeIds.map((id, i) => ({
        id, name: firmnessNames[i], price: 6270000
      }))
    };

    config.topper = [
      { id: '52008278884716', name: 'Prestige 180 × 210', price: 879000 },
      { id: '52008278360428', name: 'Premium 180 × 210', price: 1319000 },
      { id: '52037488410988', name: 'Luxury 180 × 210', price: 1759000 }
    ];
  }

  if (size === '210x200') {
    config.width = 210;
    config.length = 200;
    config.base = {
      id: '54493794795884',
      name: 'Hällsö Walnut 210 × 200 – ramme',
      price: 7526000
    };

    const ids = [
      '52037486969196', '52037487001964',
      '52037487034732', '52037487067500',
      '52037487100268', '52037487133036',
      '52037487165804', '52037487198572',
      '52037487231340', '52037487264108'
    ];

    config.mattresses = {
      store: ids.map((id, i) => ({
        id, name: firmnessNames[i], price: 6156000
      }))
    };

    root.querySelector('select[name="mattress"] option[value="lille"]')?.remove();

    config.topper = [
      { id: '52008278917484', name: 'Prestige 210 × 200', price: 900000 },
      { id: '52008278393196', name: 'Premium 210 × 200', price: 1323000 },
      { id: '52037488443756', name: 'Luxury 210 × 200', price: 1897000 }
    ];
  }

  if (size === '210x210') {
    config.width = 210;
    config.length = 210;
    config.base = {
      id: '54493794861420',
      name: 'Hällsö Walnut 210 × 210 – ramme',
      price: 8278600
    };

    const ids = [
      '52037487296876', '52037487329644',
      '52037487362412', '52037487395180',
      '52037487427948', '52037487460716',
      '52037487493484', '52037487526252',
      '52037487559020', '52037487591788'
    ];

    config.mattresses = {
      store: ids.map((id, i) => ({
        id, name: firmnessNames[i], price: 6772000
      }))
    };

    root.querySelector('select[name="mattress"] option[value="lille"]')?.remove();

    config.topper = [
      { id: '52008278950252', name: 'Prestige 210 × 210', price: 990000 },
      { id: '52008278425964', name: 'Premium 210 × 210', price: 1455000 },
      { id: '52037488476524', name: 'Luxury 210 × 210', price: 2087000 }
    ];
  }

  const mainImage = root.querySelector('.cdb-v2__media > img');

  if (mainImage) {
    mainImage.style.cursor = 'zoom-in';
    mainImage.title = 'Forstørr produktbildet';
    mainImage.addEventListener('click', () => {
      const viewer = window.open(
        mainImage.currentSrc || mainImage.src,
        '_blank',
        'noopener,noreferrer'
      );
      if (viewer) viewer.opener = null;
    });
  }

  if (isFabric) {
    const fabricBaseIds = {'180x200':'54493794632044','180x210':'54493794697580','210x200':'54493794763116','210x210':'54493794828652'};
    if (!fabricBaseIds[size]) throw Error('Ukjent Hällsö Fabric-størrelse.');
    config.base.id = fabricBaseIds[size];
    config.base.name = 'Hällsö Fabric ' + config.width + ' × ' + config.length + ' – ramme';
  }

  const productHeading = root.querySelector('[data-hallso-heading]');
  if (productHeading) {
    productHeading.textContent = 'Hällsö ' + (isFabric ? 'Fabric ' : 'Walnut ') +
      config.width + ' × ' + config.length;
  }

  const fabrics = JSON.parse(root.querySelector('[data-fabrics]').textContent);
  const form = root.querySelector('form');
  const status = root.querySelector('[data-status]');
  const button = root.querySelector('[data-check]');
  const cylindoImage = root.querySelector('[data-hallso-cylindo]');

  // Bekreftede Cylindo-koder for alle 10 gavler.
  const headboardCodes = {
    // Pinnö
    '52037477499244': 'PINNO 186 CM',
    '52037477564780': 'PINNO 282 CM WITHOUT SIDE TABLE',
    '52037477597548': 'PINNO 282 CM WITH SIDE TABLE',

    // Pinnö med Sälö
    '52037477007724': 'PINNO 186 CM WITH SALO',
    '52037477073260': 'PINNO 282 CM WITHOUT SIDE TABLE WITH SALO',

    // Otterö Walnut
    '52037477106028': 'OTTERO WALNUT 186 CM',
    '52037477171564': 'OTTERO WALNUT 282 CM',

    // Otterö Walnut med Sälö
    '52037477237100': 'OTTERO WALNUT 186 CM WITH SALO',
    '52037477302636': 'OTTERO WALNUT 282 CM WITH SALO',

    // Rivö
    '52037477794156': 'RIVO'
  };

  const standardCodes = {
    'cliff light grey': 'CLIFF_LIGHT_GREY',
    'luxury black': 'LUXURY_BLACK',
    'luxury dark grey': 'LUXURY_DARK_GREY',
    'luxury light grey': 'LUXURY_LIGHT_GREY',
    'luxury sand': 'LUXURY_SAND',
    'wool beige': 'BEIGE_WOOL',
    'wool black': 'BLACK_WOOL',
    'wool dark grey': 'DARK_GREY_WOOL',
    'wool light grey': 'LIGHT_GREY_WOOL',
    'designers guild zaragoza eggshell': 'DG_ZARAGOZA_EGGSHELL',
    'designers guild zaragoza pebble': 'DG_ZARAGOZA_PEBBLE',
    'designers guild zaragoza steel': 'DG_ZARAGOZA_STEEL',
    'designers guild rothesay graphite': 'DG_ROTHESAY_GRAPHITE',
    'designers guild rothesay pumice': 'DG_ROTHESAY_PUMICE',
    'designers guild rothesay zinc': 'DG_ROTHESAY_ZINK',
    'designers guild rothesay stone': 'DG_ROTHESAY_STONE',
    'designers guild skye chalk': 'DG_SKYE_CHALK',
    'designers guild skye zinc': 'DG_SKYE_ZINC',
    'designers guild skye aqua': 'DG_SKYE_AQUA',
    'designers guild skye midnight': 'DG_SKYE_MIDNIGHT'
  };

  const exclusiveCodes = {
    '00': 'DG_GLENVILLE_ZINC',
    '01': 'DG_GLENVILLE_GRANITE',
    '02': 'DG_GLENVILLE_CELADON',
    '03': 'DG_GLENVILLE_OYSTER',
    '16': 'RO_ASURI_CASHEW',
    '18': 'RO_ASURI_MULBERRY',
    '19': 'RO_ASURI_ROSE',
    '20': 'RO_ASURI_ANTLER',
    '21': 'RO_ASURI_PIGEON',
    '22': 'DG_AZUARA_ECRU',
    '23': 'DG_AZUARA_NATURAL',
    '24': 'RO_LOOP_OYSTER',
    '25': 'RO_LOOP_STONE',
    '26': 'RO_LOOP_EVERGREEN',
    '27': 'RO_LOOP_MARINE',
    '28': 'DG_NOTTHING_HILL_SLATE',
    '29': 'DG_DERWEN_JAPANESE_INK',
    '30': 'DG_DERWEN_RETRO_OLIVE',
    '31': 'KV_MELANGE_NAP211',
    '32': 'KV_MELANGE_NAP111',
    '33': 'KV_MELANGE_NAP191',
    '34': 'KV_FIORD2_322',
    '35': 'KV_FIORD2_262',
    '37': 'DG_SKYE_CHALK',
    '38': 'DG_SKYE_ZINC',
    '39': 'DG_SKYE_AQUA',
    '40': 'DG_SKYE_MIDNIGHT'
  };

  const updateCylindo = () => {
    if (!cylindoImage || isFabric) return;

    const mattress = form.elements.mattress.value;
    const topper = config.topper.find(
      x => x.id === form.elements.topper.value
    );

    const selectedFabric = fabrics.find(
      x => x.key === form.elements.fabric.value
    );

    const fabricName = (selectedFabric?.name || '')
      .toLowerCase()
      .replace(/\s+e\d+$/i, '')
      .trim();

    const exclusiveMatch = (selectedFabric?.name || '')
      .match(/\bE(\d{2})\b/i);

    const upholstery = exclusiveMatch
      ? exclusiveCodes[exclusiveMatch[1]] || standardCodes[fabricName]
      : standardCodes[fabricName];

    if (!upholstery) return;

    const selectedHeadboard = config.headboards.find(
  x => String(x.id) === String(form.elements.headboard.value)
);

    const headboardCode = selectedHeadboard
      ? headboardCodes[String(selectedHeadboard.id)] || 'OFF'
      : 'OFF';

    const topperCode = topper?.name.startsWith('Luxury')
      ? 'LUXURY'
      : topper?.name.startsWith('Premium')
        ? 'PREMIUM'
        : topper?.name.startsWith('Prestige')
          ? 'PRESTIGE'
          : 'OFF';

    const mattressCode = mattress === 'store'
      ? 'LARGE HARPO'
      : mattress === 'lille'
        ? 'SMALL HARPO'
        : 'OFF';

    const features = [
      ['UPHOLSTERY', upholstery],
      ['MATTRESS TYPE', mattressCode],
      ['TOP MATTRESS', topperCode],
      ['HEADBOARD TYPE', headboardCode],
      ['BEDSIDE TABLE', 'OFF']
    ];

    const url =
      'https://content.cylindo.com/api/v2/6137/products/' +
      'HALLSO%20WALNUT/frames/3/HALLSO%20WALNUT.webp' +
      '?removeEnvironmentShadow=false&size=768' +
      features.map(([key, value]) =>
        '&feature=' +
        encodeURIComponent(key) + ':' +
        encodeURIComponent(value)
      ).join('');

    if (cylindoImage.src !== url) cylindoImage.src = url;
  };

  form.addEventListener('change', updateCylindo);

  const money = n => new Intl.NumberFormat('nb-NO', {
    style: 'currency',
    currency: 'NOK',
    maximumFractionDigits: 0
  }).format(n / 100);

  const fill = (name, items) => {
    items.forEach(x => form.elements[name].add(new Option(x.name, x.id)));
  };

  const labels = {
    Soft: 'Myk',
    Medium: 'Medium',
    Firm: 'Fast',
    'Extra Firm': 'Ekstra fast'
  };

  for (const side of ['left', 'right']) {
    fill(side, config.firmness.map(v => ({
      id: v, name: labels[v]
    })));
    form.elements[side].value = 'Medium';
  }

  fill('topper', [
    { id: '', name: 'Uten overmadrass' },
    ...config.topper.map(x => ({
      ...x,
      name: x.name + ' · ' + money(x.price)
    }))
  ]);

  form.elements.topper.value =
    config.topper.find(x => x.name.startsWith('Luxury')).id;

  fill('headboard', [
    { id: '', name: 'Uten gavl' },
    ...config.headboards.map(x => ({
      ...x,
      name: x.name + ' · ' + money(x.price)
    }))
  ]);

  fill('fabric', fabrics.map(f => ({
    id: f.key,
    name: f.name + ' · ' + f.collection
  })));

  const compareAtById = new Map();
  const framePrice=root.querySelector('[data-hallso-frame-price]');
  const frameCompare=root.querySelector('[data-hallso-frame-compare]');
  const frameBadge=root.querySelector('[data-hallso-frame-badge]');
  const renderFramePrice=()=>{const base=config.base;const old=compareAtById.get(String(base.id));const sale=old>base.price;framePrice.textContent=money(base.price);frameCompare.hidden=!sale;frameCompare.textContent=sale?money(old):'';frameBadge.hidden=!sale;frameBadge.textContent=sale?'−'+Math.round((old-base.price)*100/old)+' % rabatt':'';};
  renderFramePrice();

  const allItems = [
    config.base,
    ...Object.values(config.mattresses).flat(),
    ...config.topper,
    ...config.headboards,
    ...Object.values(config.fees)
  ];

  let current;
  let busy = false;

  function update() {
    const hasMattress = Boolean(form.elements.mattress.value);

    root.querySelector('[data-firmness]').hidden = !hasMattress;
    form.elements.left.disabled =
      form.elements.right.disabled = !hasMattress;

    const choice = Object.fromEntries(new FormData(form));
    const fabric = fabrics.find(f => f.key === choice.fabric);
    const swatch = root.querySelector('[data-swatch]');

    swatch.hidden = !fabric?.swatch_url;

    if (fabric?.swatch_url) {
      swatch.src = fabric.swatch_url;
      swatch.alt = fabric.name;
    }

    try {
      current = hallsoBuild(config, choice, fabrics, 'pilot-preview');

      const rows = root.querySelector('tbody');
      rows.replaceChildren();

      current.lines.forEach(l => {
        const row = document.createElement('tr');
        const name = document.createElement('td');
        const price = document.createElement('td');

        name.textContent =
          (l.quantity > 1 ? l.quantity + ' × ' : '') + l.name;
        const compare = compareAtById.get(String(l.id));
        if (compare && compare > l.unitPrice) {
          const oldPrice = document.createElement('s');
          oldPrice.className = 'hallso-compare-line';
          oldPrice.textContent = money(compare * l.quantity);
          price.append(oldPrice);
        }
        const currentPrice = document.createElement('strong');
        currentPrice.textContent = money(l.unitPrice * l.quantity);
        price.append(currentPrice);

        row.append(name, price);
        rows.append(row);
      });

      root.querySelector('[data-total]').textContent = money(current.total);
      const fullTotal = current.lines.reduce((sum, l) => {
        const compare = compareAtById.get(String(l.id));
        return sum + Math.max(l.unitPrice, compare || l.unitPrice) * l.quantity;
      }, 0);
      const totalCompare = root.querySelector('[data-total-compare]');
      const totalSaving = root.querySelector('[data-total-saving]');
      const onSale = fullTotal > current.total;
      const discountBadge=root.querySelector('[data-hallso-discount-badge]');
      if(discountBadge){discountBadge.hidden=!onSale;discountBadge.textContent=onSale?'−'+Math.round((1-current.total/fullTotal)*100)+' % rabatt':'';}
      totalCompare.hidden = !onSale;
      totalSaving.hidden = !onSale;
      totalCompare.textContent = onSale ? money(fullTotal) : '';
      totalSaving.textContent = onSale ? 'Du sparer ' + money(fullTotal - current.total) : '';
      status.textContent = 'Valgene dine er klare.';
      button.disabled = busy;
    } catch (e) {
      current = null;
      button.disabled = true;
      status.textContent = e.message;
      root.querySelector('[data-total]').textContent = '—';
      root.querySelector('[data-total-compare]').hidden = true;
      root.querySelector('[data-total-saving]').hidden = true;
      root.querySelector('tbody').replaceChildren();
    }
  }

  // Hent oppdaterte priser fra Shopify.
  let priceRefreshToken = 0;

  async function refreshSelectedPrices() {
    const token = ++priceRefreshToken;
    update();

    if (!current || busy) return;

    const selected = current.lines.map(line => ({
      id: line.id, name: line.name
    }));

    status.textContent = 'Oppdaterer priser fra Shopify…';
    button.disabled = true;

    try {
      const variants = await Promise.all(selected.map(async line => {
        const response = await fetch(
          (window.Shopify?.routes?.root || '/') +
          'variants/' + line.id + '.js',
          {
            cache: 'no-store',
            headers: { Accept: 'application/json' }
          }
        );

        if (!response.ok) {
          throw Error('Kunne ikke hente oppdatert pris for ' + line.name);
        }

        const variant = await response.json();

        if (
          String(variant.id) !== line.id ||
          !Number.isSafeInteger(variant.price) ||
          variant.price < 0
        ) {
          throw Error('Ugyldig pris for ' + line.name);
        }

        if (!variant.available) {
          throw Error(line.name + ' er ikke tilgjengelig akkurat nå.');
        }

        return variant;
      }));

      if (token !== priceRefreshToken) return;

      for (const variant of variants) {
        const item = allItems.find(x => x.id === String(variant.id));
        if (item) item.price = variant.price;
        if (Number.isSafeInteger(variant.compare_at_price) && variant.compare_at_price > variant.price) {
          compareAtById.set(String(variant.id), variant.compare_at_price);
        } else {
          compareAtById.delete(String(variant.id));
        }
      }

      renderFramePrice();
      update();
      status.textContent = 'Prisene er oppdatert fra Shopify.';
    } catch (error) {
      if (token !== priceRefreshToken) return;
      status.textContent = error.message;
      button.disabled = true;
    }
  }

  form.addEventListener('submit', e => e.preventDefault());
  form.addEventListener('change', refreshSelectedPrices);

  button.addEventListener('click', async () => {
    if (!current || busy) return;

    busy = true;
    button.disabled = true;
    status.textContent = 'Kontrollerer pris og tilgjengelighet…';

    const fingerprint = JSON.stringify(
      Object.fromEntries(new FormData(form))
    );

    try {
      const selected = current.lines.map(line => ({
        id: line.id, name: line.name
      }));

      const results = await Promise.all(selected.map(async line => {
        const response = await fetch(
          (window.Shopify?.routes?.root || '/') +
          'variants/' + line.id + '.js',
          {
            cache: 'no-store',
            headers: { Accept: 'application/json' }
          }
        );

        if (!response.ok) {
          throw Error('Kunne ikke kontrollere ' + line.name);
        }

        const v = await response.json();

        if (!v.available) {
          throw Error(line.name + ' er ikke tilgjengelig.');
        }

        if (
          String(v.id) !== line.id ||
          !Number.isSafeInteger(v.price) ||
          v.price < 0
        ) {
          throw Error('Ugyldig variantdata.');
        }

        return v;
      }));

      if (
        fingerprint !== JSON.stringify(
          Object.fromEntries(new FormData(form))
        )
      ) {
        throw Error('Valgene ble endret. Prøv igjen.');
      }

      let changed = false;

      for (const v of results) {
        const item = allItems.find(x => x.id === String(v.id));

        if (!item) throw Error('Komponenten finnes ikke.');

        if (item.price !== v.price) {
          item.price = v.price;
          changed = true;
        }
      }

      for (const v of results) {
        if (Number.isSafeInteger(v.compare_at_price) && v.compare_at_price > v.price) {
          compareAtById.set(String(v.id), v.compare_at_price);
        } else {
          compareAtById.delete(String(v.id));
        }
      }
      update();

      if (changed) {
        status.textContent =
          'Prisene ble oppdatert. Kontroller totalprisen og ' +
          'trykk igjen for å legge i handlekurven.';
        return;
      }

      if (
        !current ||
        fingerprint !== JSON.stringify(
          Object.fromEntries(new FormData(form))
        )
      ) {
        throw Error('Konfigurasjonen ble endret.');
      }

      const cartResponse = await fetch(
        (window.Shopify?.routes?.root || '/') + 'cart/add.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify(current.cart)
        }
      );

      const cartResult = await cartResponse.json();

      if (!cartResponse.ok) {
        throw Error(
          cartResult.description ||
          cartResult.message ||
          'Kunne ikke legge til i handlekurven.'
        );
      }

      status.textContent = 'Konfigurasjonen er lagt i handlekurven.';

      window.location.assign(
        (window.Shopify?.routes?.root || '/') + 'cart'
      );
    } catch (e) {
      status.textContent = e.message;
    } finally {
      busy = false;
      button.disabled = !current;
    }
  });

  // Visuelle valgkort.
  const visualNames = [
    'mattress', 'left', 'right', 'topper'
  ];

  const refreshCards = () => {
    visualNames.forEach(name => {
      const select = form.elements[name];
      if (!select) return;

      let wrap = select.nextElementSibling;

      if (!wrap?.classList.contains('hallso-choice-cards')) {
        wrap = document.createElement('div');
        wrap.className = 'hallso-choice-cards' +
          (name === 'mattress' ? ' hallso-mattress-cards' : '');

        select.after(wrap);
        select.classList.add('hallso-native-select');
      }

      const options = Array.from(select.options);

      if (wrap.childElementCount !== options.length) {
        wrap.replaceChildren();

        options.forEach(o => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'hallso-choice-card';
          b.dataset.value = o.value;

          if (name === 'fabric') {
            const fabric = fabrics.find(f => f.key === o.value);
            const img = document.createElement('img');
            img.className = 'hallso-fabric-swatch';
            img.alt = fabric?.name || '';
            img.loading = 'lazy';
            if (fabric?.swatch_url) img.src = fabric.swatch_url;
            b.append(img);
          }

          if (name === 'topper') {
            const top = config.topper.find(t => t.id === o.value);
            const topperImages = {
  Prestige: 'https://cdn.shopify.com/s/files/1/0911/4668/2732/files/Prestige-overmadrass-Carpe-Diem-Beds.webp?v=1787574183',
  Premium: 'https://cdn.shopify.com/s/files/1/0911/4668/2732/files/Premium-overmadrass-Carpe-Diem-Beds2.webp?v=1760425502',
  Luxury: 'https://cdn.shopify.com/s/files/1/0911/4668/2732/files/Luxury_overmadrass_carpe_diem_beds.webp?v=1749112004'
};
            const type = top?.name.split(' ')[0];
            if (type && topperImages[type]) {
              const img = document.createElement('img');
              img.className = 'hallso-topper-image';
              img.src = topperImages[type];
              img.alt = type + ' overmadrass';
              img.loading = 'lazy';
              b.append(img);
            } else {
              const empty = document.createElement('div');
              empty.className = 'hallso-topper-empty';
              empty.textContent = '—';
              b.append(empty);
            }
          }

          if (name === 'mattress') {
            const img = document.createElement('img');
            img.className = 'hallso-mattress-image';
            img.loading = 'lazy';
            img.alt = '';

            img.src = ({
              store:
                'https://carpediembeds.com/cdn/shop/files/' +
                '5055_Stora-Harpo_2_39e687bb-196e-4d81-8dc3-' +
                '309ede147e24.jpg?crop=region&crop_height=1600' +
                '&crop_left=0&crop_top=100&crop_width=2400' +
                '&v=1748416141&width=480',
              lille:
                'https://carpediembeds.com/cdn/shop/files/' +
                '5055_Lilla-Harpo_1_0d2f3294-43b7-49ec-' +
                '85b8-6ea6a2a52a76.jpg?crop=region&crop_height=1600' +
                '&crop_left=0&crop_top=100&crop_width=2400' +
                '&v=1748416135&width=480',
              '':
                'https://bedtime.no/cdn/shop/files/' +
                (isFabric ? 'HALLSO_20UPHOLSTERY.webp?v=1757667508&width=768' : 'HALLSO_20WALNUT.webp?v=1757667518&width=1946')
            })[o.value];

            b.append(img);
          }

          const label = document.createElement('span');
          label.textContent = o.textContent;
          b.append(label);

          b.addEventListener('click', () => {
            select.value = o.value;
            select.dispatchEvent(
              new Event('change', { bubbles: true })
            );
          });

          wrap.append(b);
        });
      }

      wrap.hidden =
        select.disabled || select.closest('[hidden]') !== null;

      wrap.querySelectorAll('button.hallso-choice-card').forEach(b => {
        const selected = b.dataset.value === select.value;
        b.classList.toggle('is-selected', selected);
        b.setAttribute('aria-pressed', String(selected));
      });
    });
  };


  // Malö-inspired fabric swatches: eight choices and a full fabric dialog.
  const fabricSelect = form.elements.fabric;
  fabricSelect.classList.add('hallso-native-select');
  const fabricPanel = document.createElement('div');
  fabricPanel.className = 'hallso-fabric-panel';
  const fabricSelected = document.createElement('div');
  fabricSelected.className = 'hallso-fabric-selected';
  const fabricGrid = document.createElement('div');
  fabricGrid.className = 'hallso-fabric-grid';
  const fabricMore = document.createElement('button');
  fabricMore.type = 'button';
  fabricMore.className = 'hallso-fabric-more';
  fabricMore.textContent = 'VIS ALLE TEKSTILER';
  const fabricNote = document.createElement('p');
  fabricNote.className = 'hallso-fabric-note';
  fabricNote.textContent = 'Classic er inkludert. Exclusive har pristillegg.';
  fabricPanel.append(fabricSelected, fabricGrid, fabricMore, fabricNote);
  fabricSelect.after(fabricPanel);
  const maloFabricUrls = {"Cliff Light Grey":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-cliff-light-grey.jpg?v=1790248092","Luxury Black":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-luxury-black.jpg?v=1790248093","Luxury Dark Grey":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-luxury-dark-grey.jpg?v=1790248093","Luxury Light Grey":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-luxury-light-grey.jpg?v=1790248094","Luxury Sand":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-luxury-sand.jpg?v=1790248094","Wool Beige":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-wool-beige.jpg?v=1790248094","Wool Dark Grey":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-wool-dark-grey.jpg?v=1790248093","Wool Light Grey":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-wool-light-grey.jpg?v=1790248094","Wool Black":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-wool-black.jpg?v=1790248094","Designers Guild Zaragoza Eggshell":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-zaragoza-eggshell.jpg?v=1790248094","Designers Guild Zaragoza Pebble":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-zaragoza-pebble.jpg?v=1790248094","Designers Guild Zaragoza Steel":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-zaragoza-steel.jpg?v=1790248094","Designers Guild Rothesay Stone":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-rothesay-stone.jpg?v=1790248093","Designers Guild Rothesay Zinc":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-rothesay-zinc.jpg?v=1790248094","Designers Guild Rothesay Pumice":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-rothesay-pumice.jpg?v=1790248094","Designers Guild Rothesay Graphite":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-rothesay-graphite.jpg?v=1790248094","Designers Guild Glenville Celadon E02":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-glenville-celadon.jpg?v=1790248094","Designers Guild Glenville Granite E01":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-glenville-granite.jpg?v=1790248094","Designers Guild Glenville Oyster E03":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-glenville-oyster.jpg?v=1790248094","Designers Guild Glenville Zinc E00":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-glenville-zinc.jpg?v=1790248094","Designers Guild Azuara Ecru E22":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-azuara-ecru.jpg?v=1790248094","Designers Guild Azuara Natural E23":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-azuara-natural.jpg?v=1790248094","Designers Guild Skye Chalk E37":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-skye-chalk.jpg?v=1790248094","Designers Guild Skye Aqua E39":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-skye-aqua.jpg?v=1790248093","Designers Guild Skye Midnight E40":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-skye-midnight.jpg?v=1790248094","Designers Guild Skye Zinc E38":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-skye-zinc.jpg?v=1790248094","Designers Guild Derwen Japanese Ink E29":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-derwen-japanese-ink.jpg?v=1790248094","Designers Guild Derwen Notting Hill E28":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-derwen-notting-hill.jpg?v=1790248094","Designers Guild Derwen Retro Olive E30":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-derwen-retro-olive.jpg?v=1790248094","Romo Group Asuri Cashew E16":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-asuri-cashew.jpg?v=1790248094","Romo Group Asuri Rose Quartz E19":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-asuri-rose.jpg?v=1790248094","Romo Group Asuri Mulberry E18":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-asuri-mulberry.jpg?v=1790248094","Romo Group Asuri Pigeon E21":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-asuri-pigeon.jpg?v=1790248094","Romo Group Asuri Antler E20":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-asuri-antler.jpg?v=1790248094","Romo Group Loop Oyster E24":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-loop-oyster.jpg?v=1790248094","Romo Group Loop Stone E25":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-loop-stone.jpg?v=1790248094","Romo Group Loop Evergreen E26":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-loop-evergreen.jpg?v=1790248094","Romo Group Loop Marine E27":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-loop-marine.jpg?v=1790248094","Kvadrat Fiord2 262 Light Brown E35":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-fiord2-262.jpg?v=1790248094","Kvadrat Fiord2 171 Dark Grey":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-fiord2-171.jpg?v=1790248094","Kvadrat Fiord2 322 Beige E34":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-fiord2-322.jpg?v=1790248094","Kvadrat Melange NAP 111 Light Grey E32":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-melange-nap-111.jpg?v=1790248094","Kvadrat Melange NAP 211 Beige E31":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-melange-nap-211.jpg?v=1790248094","Kvadrat Melange NAP 191 Dark Grey E33":"https://cdn.shopify.com/s/files/1/0911/4668/2732/files/cdb-original-melange-nap-191.jpg?v=1790248094"};
  const fabricUrl = f => maloFabricUrls[f.name] || f.swatch_url || '';
  const fabricDialog = document.createElement('dialog');
  fabricDialog.className = 'hallso-fabric-dialog';
  const fabricDialogTitle = document.createElement('h2');
  fabricDialogTitle.textContent = 'Velg tekstil';
  const fabricDialogHelp = document.createElement('p');
  fabricDialogHelp.textContent = 'Velg blant Classic og Exclusive. Eventuelt pristillegg oppdateres automatisk.';
  const fabricClose = document.createElement('button');
  fabricClose.type = 'button';
  fabricClose.className = 'hallso-fabric-close';
  fabricClose.textContent = 'Lukk';
  const fabricChoices = document.createElement('div');
  fabricChoices.className = 'hallso-fabric-dialog-list';
  fabricDialog.append(fabricDialogTitle, fabricDialogHelp, fabricClose, fabricChoices);
  root.append(fabricDialog);
  fabricClose.addEventListener('click', () => fabricDialog.close());
  fabricDialog.addEventListener('click', e => {
    if (e.target === fabricDialog) fabricDialog.close();
  });
  const chooseFabric = f => {
    fabricSelect.value = f.key;
    fabricSelect.dispatchEvent(new Event('change', { bubbles: true }));
  };
  const hallsoZoomDialog=document.createElement('dialog');
  hallsoZoomDialog.className='hallso-zoom-dialog';
  const hallsoZoomClose=document.createElement('button');hallsoZoomClose.type='button';hallsoZoomClose.textContent='Lukk';hallsoZoomClose.className='hallso-zoom-close';
  const hallsoZoomTitle=document.createElement('h3');
  const hallsoZoomImage=document.createElement('img');hallsoZoomImage.alt='';
  hallsoZoomDialog.append(hallsoZoomClose,hallsoZoomTitle,hallsoZoomImage);root.append(hallsoZoomDialog);
  hallsoZoomClose.addEventListener('click',()=>hallsoZoomDialog.close());
  hallsoZoomDialog.addEventListener('click',e=>{if(e.target===hallsoZoomDialog)hallsoZoomDialog.close();});
  const hallsoOpenZoom=(url,title)=>{if(!url)return;hallsoZoomImage.src=url;hallsoZoomImage.alt=title;hallsoZoomTitle.textContent=title;hallsoZoomDialog.showModal();};
  const hallsoAddZoom=(card,url,title)=>{if(!url)return;card.style.position='relative';const z=document.createElement('span');z.className='hallso-zoom-icon';z.setAttribute('role','button');z.setAttribute('tabindex','0');z.setAttribute('aria-label','Forstørr '+title);z.innerHTML='<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>';const show=e=>{e.preventDefault();e.stopPropagation();hallsoOpenZoom(url,title);};z.addEventListener('click',show);z.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){show(e);}});card.append(z);};
  const makeFabricButton = (f, modal = false) => {
    const b = document.createElement('div');
    b.setAttribute('role', 'button');
    b.setAttribute('tabindex', '0');
    b.className = modal ? 'hallso-fabric-option' : 'hallso-fabric-swatch-button';
    b.title = f.name;
    b.setAttribute('aria-label', f.name);
    b.dataset.fabric = f.key;
    const img = document.createElement('img');
    img.src = fabricUrl(f);
    img.alt = f.name;
    img.loading = 'lazy';
    b.append(img);
    hallsoAddZoom(b,img.src,f.name);
    if (modal) {
      const details = document.createElement('span');
      details.textContent = f.name + ' · ' + (f.collection === 'Exclusive' ? 'Exclusive · pristillegg' : 'Classic · inkludert');
      b.append(details);
    }
    const selectThisFabric = () => { chooseFabric(f); if (modal) fabricDialog.close(); };
    b.addEventListener('click', selectThisFabric);
    b.addEventListener('keydown', e => {
      if (e.target === b && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); selectThisFabric(); }
    });
    return b;
  };
  fabrics.slice(0, 8).forEach(f => fabricGrid.append(makeFabricButton(f)));
  ['Classic', 'Exclusive'].forEach(group => {
    const heading = document.createElement('h3');
    heading.textContent = group;
    fabricChoices.append(heading);
    const grid = document.createElement('div');
    grid.className = 'hallso-fabric-dialog-grid';
    fabrics.filter(f => f.collection === group).forEach(f => grid.append(makeFabricButton(f, true)));
    fabricChoices.append(grid);
  });
  const renderFabric = () => {
    const f = fabrics.find(x => x.key === fabricSelect.value);
    if (!f) return;
    fabricSelected.textContent = f.name + ' · ' + (f.collection === 'Exclusive' ? 'Exclusive · pristillegg' : 'Classic · inkludert');
    root.querySelectorAll('[data-fabric]').forEach(b => {
      const active = b.dataset.fabric === f.key;
      b.classList.toggle('is-selected', active);
      b.setAttribute('aria-pressed', String(active));
    });
  };
  fabricMore.addEventListener('click', () => {
    renderFabric();
    fabricDialog.showModal();
  });
  form.addEventListener('change', renderFabric);
  renderFabric();

  // Gavlvalg i separat dialog.
  const headboardSelect = form.elements.headboard;
  headboardSelect.classList.add('hallso-native-select');

  const headboardTrigger = document.createElement('button');
  headboardTrigger.type = 'button';
  headboardTrigger.className = 'hallso-headboard-trigger';
  headboardSelect.after(headboardTrigger);

  const dialog = document.createElement('dialog');
  dialog.className = 'hallso-headboard-dialog';

  const heading = document.createElement('h2');
  heading.textContent = 'Velg gavl';

  const help = document.createElement('p');
  help.textContent =
    'Velg modell og størrelse. Prisen oppdateres automatisk.';

  const close = document.createElement('button');
  close.type = 'button';
  close.className = 'hallso-dialog-close';
  close.textContent = 'Lukk';
  close.addEventListener('click', () => dialog.close());

  const gallery = document.createElement('div');
  gallery.className = 'hallso-headboard-gallery';

  dialog.append(heading, help, close, gallery);
  root.append(dialog);

  const groupLabel = name => name
    .replace(/\b\d{2,3}\s*[×xX]\s*\d{2,3}\b/g, '')
    .replace(/\b\d{2,3}\s*(?:cm)?\b/g, '')
    .replace(/[·–-]\s*kr.*$/i, '')
    .replace(/\s+/g, ' ')
    .trim() || 'Gavl';

  const renderHeadboards = () => {
    const selected = headboardSelect.selectedOptions[0];

    headboardTrigger.textContent =
      'Gavl: ' + (selected?.textContent || 'Velg gavl') + '  ›';

    gallery.replaceChildren();

    const groups = new Map();

    for (const option of headboardSelect.options) {
      const label = option.value
        ? groupLabel(option.textContent.split(' · ')[0])
        : 'Uten gavl';

      if (!groups.has(label)) groups.set(label, []);
      groups.get(label).push(option);
    }

    for (const [label, options] of groups) {
      const section = document.createElement('section');
      section.className = 'hallso-headboard-group';

      const title = document.createElement('h3');
      title.textContent = label;
      section.append(title);

      const choices = document.createElement('div');
      choices.className = 'hallso-headboard-options';

      for (const option of options) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'hallso-headboard-option';
        if (option.value) {
          const code = headboardCodes[String(option.value)];
          if (code) {
            const img = document.createElement('img');
            img.className = 'hallso-headboard-image';
            img.alt = option.textContent.split(' · ')[0];
            img.loading = 'lazy';
            img.src = 'https://content.cylindo.com/api/v2/6137/products/HALLSO%20WALNUT/frames/31/HALLSO%20WALNUT.webp?removeEnvironmentShadow=false&size=256&feature=UPHOLSTERY:CLIFF_LIGHT_GREY&feature=MATTRESS%20TYPE:OFF&feature=TOP%20MATTRESS:OFF&feature=HEADBOARD%20TYPE:' + encodeURIComponent(code) + '&feature=BEDSIDE%20TABLE:OFF';
            btn.append(img);
            hallsoAddZoom(btn,img.src,img.alt);
          }
        }
        const btnText = document.createElement('span');
        btnText.textContent = option.textContent;
        btn.append(btnText);

        btn.setAttribute(
          'aria-pressed',
          String(option.value === headboardSelect.value)
        );

        if (option.value === headboardSelect.value) {
          btn.classList.add('is-selected');
        }

        btn.addEventListener('click', () => {
          headboardSelect.value = option.value;
          headboardSelect.dispatchEvent(
            new Event('change', { bubbles: true })
          );
          dialog.close();
        });

        choices.append(btn);
      }

      section.append(choices);
      gallery.append(section);
    }
  };

  headboardTrigger.addEventListener('click', () => {
    renderHeadboards();
    dialog.showModal();
  });

  dialog.addEventListener('click', event => {
    if (event.target === dialog) dialog.close();
  });

  form.addEventListener('change', () => {
    queueMicrotask(refreshCards);
    renderHeadboards();
  });

  refreshCards();
  renderHeadboards();
  refreshSelectedPrices();
})();

